import { ApiResponse } from 'apisauce';
import { AxiosHeaders } from 'axios';

interface CommonParams {
  ok: boolean;
}

interface OkResponse<T> extends CommonParams {
  ok: true;
  data?: T;
}

interface ErrorResponse<U> extends CommonParams {
  ok: false;
  data?: U;
}

type CreateApiSauceResponseParams<T, U = T> = OkResponse<T> | ErrorResponse<U>;

export const createApiSauceResponse = <T, U = T>({
  ok,
  data,
}: CreateApiSauceResponseParams<T, U>): ApiResponse<T, U> => {
  if (ok) {
    return {
      ok,
      data,
      problem: null,
      originalError: null,
    };
  }

  return {
    ok,
    data,
    problem: 'UNKNOWN_ERROR',
    originalError: {
      name: '',
      stack: '',
      config: { headers: new AxiosHeaders() },
      message: '',
      toJSON: () => ({}),
      isAxiosError: false,
    },
  };
};
